import { TagType } from '@commerce-product-webcomponents/sdk';
import { Theme } from '@nextgen-web-framework/all';

export const calculateTheme = (type: string) => {
  switch (type) {
    case TagType.Bundle:
    case TagType.Subscription:
      return Theme.BLUE;

    default:
      return Theme.PURPLE;
  }
};

export const getTagLabel = (entity: string, value: string, isUserTypeMatched: boolean) =>
  isUserTypeMatched && entity ? entity : value;
